import { db } from '@/firebaseApp'
import Guests, { Guest, GuestList } from '@/services/Guests'

export type Room = {
  id: string
  name: string
  size: number
  guestVolume: number
  artistVolume: number
  count?: number
  private?: boolean
  isEndRoom?: boolean
  sortingOrder: number
}

export type RoomsList = {
  [index: string]: Room
}

class Rooms {
  async createRoom(restaurantId: string, room: Room) {
    await db.ref(`restaurants/${restaurantId}/rooms`).push(room)
  }

  async updateRoom(restaurantId: string, roomId: string, room: Room) {
    await db.ref(`restaurants/${restaurantId}/rooms/${roomId}`).update(room)
  }

  async changeRoomOrder(restaurantId: string, roomId: string, sortingOrder: number) {
    await db.ref(`restaurants/${restaurantId}/rooms/${roomId}`).update({ sortingOrder })
  }

  observeRooms(restaurantId: string, f: (rooms: Room[]) => void) {
    db.ref(`restaurants/${restaurantId}/rooms`)
      .orderByChild('name')
      .on('value', s =>
        f(
          Object.keys(s.val())
            .map(roomId => ({ ...s.val()[roomId], id: roomId }))
            .sort((a, b) => a.sortingOrder - b.sortingOrder)
        )
      )
  }

  observeRoom(restaurantId: string, roomId: string, f: (room: Room) => void) {
    db.ref(`restaurants/${restaurantId}/rooms/${roomId}`).on('value', s => f(s.val()))
  }

  async deleteRoom(restaurantId: string, seatingId: string, roomId: string): Promise<void> {
    // Get all guests in this room first and delete their room properties
    const activeGuests: GuestList = await Guests.getActiveGuests(restaurantId, seatingId)

    for (const guestId in activeGuests) {
      const guest:Guest = activeGuests[guestId];

      // This guest is in this room, move it to the lobby
      if (guest.room && guest.room === roomId) {
        db
          .ref(`restaurants/${restaurantId}/seatings/${seatingId}/guests/${guestId}/room`)
          .remove()
      }
    }

    // Delete the room
    await db.ref(`restaurants/${restaurantId}/rooms/${roomId}`).remove()
  }
}

export default new Rooms()
